import { IonCol, IonIcon, IonInput, IonRadioGroup, IonRow, IonSelect, IonText, IonTextarea } from '@ionic/react';
import { alertCircleOutline, chevronDown } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import Picker from 'react-mobile-picker';
import Modal from 'react-responsive-modal';

import { objIsEmpty } from '../../library/Funcs';
import ActionButton from '../button/ActionButton';

import './InputItem.css';

interface Props {
    type: any,
    dateType?: "birth" | "current", // تاریخ تولد یا تاریخ های زمان حال مثل تاریخ واریز
    simple?: boolean,
    provider?: any,
    name?: string,
    label?: string,
    placeholder?: string,
    value?: any,
    icon?: any,
    maxlength?: number,
    rows?: number
    ltr?: boolean,
    spaced?: boolean,
    readonly?: boolean,
    disabled?: boolean,
    click?: any,
    change?: any,
}

const InputItem: React.FC<Props> = (props) => {
    const [select2InitLabel, setSelect2InitLabel] = useState('');

    const [datePickerEl, setDatePickerEl] = useState(null as any);
    const [datePickerError, setDatePickerError] = useState('');
    const [showDatePicker, setShowDatePicker] = useState(false);

    const [listEl, setListEl] = useState(null as any);
    const [showList, setShowList] = useState(false);
    const [listSelectedId, setListSelectedId] = useState("")

    let rootClassName = ["input-item"];
    let inputRootClassName = ["input-root"];
    let maxlength = undefined;
    let rows = undefined;
    let className = [];

    if (props.type === "textarea") rootClassName.push("multiline");

    if (props.type == 'hidden') inputRootClassName.push("ion-hide");

    if (props.type == 'select3') inputRootClassName.push("number-selector");

    if (props.maxlength) maxlength = props.maxlength;
    if (props.rows) rows = props.rows;
    if (props.ltr) className.push("ltr");
    if (props.spaced) className.push("spaced");

    const compareWith = (o1: any, o2: any) => {
        return o1 && o2 ? o1 === o2 : o1 === o2;
    }

    useEffect(() => {
        if (props.type == "select2" || props.type == "select3") {
            if (select2InitLabel == "") {
                if (props.children !== undefined && props.children != null) {
                    (props.children as Array<any>).forEach(function (item: any, index: number) {
                        if (item.props !== undefined) {
                            if (item.props.isChecked) {
                                setSelect2InitLabel(item.props.label);
                            }
                        }
                    })
                }
            }
        }
        
        setListSelectedId(props.provider?.form[props.name!].value)
    }, [props.provider?.form[props.name!].value]);

    const getElement = (props: any, className: any) => {
        if (props.type == "datepicker")
            return <IonInput name={props.name} type={'text'} autocomplete="off" maxlength={props.maxlength} readonly={true} disabled={props.disabled} placeholder={props.label} className={className.join(" ").toString()} value={props.provider?.form[props.name].value} onChange={(e: any) => { props.provider?.setValue(e); props.change?.(); }} onInput={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} onClick={(e) => { setShowDatePicker(true); setDatePickerEl(e) }} />

        else if (props.type == "select")
            return <IonSelect name={props.name} compareWith={compareWith} value={props.value || props.provider?.form[props.name].value} disabled={props.disabled} className={className.join(" ").toString()} interface="popover" placeholder={props.label} onIonChange={(e: any) => { props.provider?.setValue(e); props.change?.(e); }}>
                {props.children}
            </IonSelect>

        else if (props.type == "select2")
            return <IonInput name={props.name} type={'text'} autocomplete="off" maxlength={props.maxlength} readonly={true} disabled={props.disabled} placeholder={props.label} className={className.join(" ").toString()} value={props.provider?.form[props.name].label || select2InitLabel} onChange={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} onInput={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} onClick={props.disabled ? () => {} : (e) => { setShowList(true); setListEl(e) }} />

        else if (props.type == "select3")
            return <IonInput name={props.name} type={'text'} autocomplete="off" maxlength={props.maxlength} readonly={true} disabled={props.disabled} className={className.join(" ").toString()} value={listSelectedId || props.value} onChange={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} onInput={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} onClick={props.disabled ? () => {} : (e) => { setShowList(true); setListEl(e) }} />

        else if (props.type == "textarea")
            return <IonTextarea name={props.name} rows={props.rows} maxlength={props.maxlength} readonly={props.readonly} disabled={props.disabled} className={className.join(" ").toString()} value={props.provider?.form[props.name].value} onChange={(e: any) => { props.provider?.setValue(e); props.change?.(); }} placeholder={props.label} onInput={(e: any) => { props.provider?.setValue(e); props.change?.(e); }}></IonTextarea>

        else if (props.type == "number")
            return <IonInput name={props.name} type='tel' inputMode='numeric' pattern='[0-9]*' autocomplete="off" maxlength={props.maxlength} readonly={props.readonly} disabled={props.disabled} placeholder={props.label} className={className.join(" ").toString()} value={props.provider?.form[props.name].value} onChange={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} onInput={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} />

        else if (props.type == "tel")
            return <IonInput name={props.name} type='tel' inputMode='numeric' pattern='[0-9]*' autocomplete="off" maxlength={props.maxlength} readonly={props.readonly} disabled={props.disabled} placeholder={props.label} className={className.join(" ").toString()} value={props.provider?.form[props.name].value} onChange={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} onInput={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} />

        else
            return <IonInput name={props.name} type={props.type == 'hidden' ? 'text' : props.type} autocomplete="off" maxlength={props.maxlength} readonly={props.readonly} disabled={props.disabled} placeholder={props.label} className={className.join(" ").toString()} value={props.provider?.form[props.name].value} onChange={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} onInput={(e: any) => { props.provider?.setValue(e); props.change?.(e); }} />
    }


    /** Thousand separator and force enter number */
    const thousandSep = (val: string) => {
        let num = Number(val.replace(/\D+/g, ""));

        if (num == 0) return '';

        return num.toThousandSep();
    }

    const forceInputNumber = (event: any) => {
        const pattern = /[0-9]/g;
        let inputChar = String.fromCharCode(event.charCode);

        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    const removeInputNonNumber = (event: any) => {
        event.target.value = event.target.value.replace(/[^0-9،]/g, "");
    }


    /** Start List */
    const changeList = (e: any) => {
        setShowList(false);

        (props.children as any).forEach((element: any) => {
            if (element.props?.value == e.detail.value) {
                props.provider?.setLabelWithData(listEl, element.props.label);
            }
        });

        setListSelectedId(e.detail.value);

        props.provider?.setValueWithData(listEl, e.detail.value);
    }
    /** End List */


    /** Start Date Picker */
    const [dateValueGroups, setDateValueGroups] = useState({ day: 1, month: 'فروردین', year: window.initials?.current_year | 1400 });
    const [dateOptionGroups, setDateOptionGroups] = useState({} as any);

    const dayOptions = [];
    const monthOptions = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];
    const yearOptions = [];

    if (objIsEmpty(dateOptionGroups)) {
        for (let i = 1; i <= 31; i++) {
            dayOptions.push(i);
        }

        let startYear = 0;
        let endYear = 0;
        if (props.dateType == "current") {
            startYear = 1400;
            endYear = window.initials?.current_year | 1400;
            for (let i = startYear; i <= endYear; i++) {
                yearOptions.push(i);
            }
        }
        if (props.dateType == "birth") {
            startYear = window.initials?.current_year | 1400;
            endYear = 1300;
            for (let i = startYear; i >= endYear; i--) {
                yearOptions.push(i);
            }
        }

        setDateOptionGroups({
            day: dayOptions,
            month: monthOptions,
            year: yearOptions
        });
    }

    const handleChange = (name: string, value: string) => {
        setDateValueGroups({ ...dateValueGroups, [name]: value })
    };

    const changeDate = () => {
        setDatePickerError("")

        setShowDatePicker(false);

        props.provider?.setValueWithData(datePickerEl, dateValueGroups.year + "/" + (getNumberFull(getMonthIndex(dateValueGroups.month)) + "/" + getNumberFull(dateValueGroups.day)));
    }

    const getMonthIndex = (month: string) => {
        let index = 0;

        for (let i = 0; i < monthOptions.length; i++) {
            if (monthOptions[i] == month) {
                index = i + 1;
                break;
            }
        }

        return index;
    }

    const getNumberFull = (number: any) => {
        if (number.toString().length == 1)
            return `0${number}`;
        else
            return number;
    }
    /** End Date Picker */

    const element = !props.simple ?
        <div className={inputRootClassName.join(" ").toString()}>
            <div className="icon-container">
                <IonIcon src={props.icon} className="icon" />
            </div>
            <div className="input-container">
                {/* <IonItem lines="none"> */}
                {/* <IonLabel position="floating">{props.label}</IonLabel> */}
                {getElement(props, className)}
                {/* </IonItem> */}
            </div>
        </div> : getElement(props, className)


    return <div onClick={props.click} className={rootClassName.join(" ").toString()}>
        {element}
        {props.provider?.form[props.name!].error && props.provider?.form[props.name!].error!.length > 0 ? <div className="error"><div><IonIcon src={alertCircleOutline} /> <IonText>{props.provider?.form[props.name!].error}</IonText></div></div> : null}

        {props.type == 'datepicker' ?
            <Modal open={showDatePicker} onClose={() => setShowDatePicker(false)} center showCloseIcon={false}>
                <IonRow>
                    <IonCol size="12">
                        <Picker
                            optionGroups={dateOptionGroups}
                            valueGroups={dateValueGroups}
                            onChange={handleChange} />
                    </IonCol>
                    <IonCol size="12">
                        {datePickerError.length > 0 ? <div className="error"><div><IonIcon src={alertCircleOutline} /> <IonText>{datePickerError}</IonText></div></div> : null}
                        <ActionButton text="تایید" click={(e: any) => { changeDate() }} />
                    </IonCol>
                </IonRow>
            </Modal> : null}

        {props.type == 'select2' ?
            <Modal open={showList} onClose={() => setShowList(false)} blockScroll={false} center showCloseIcon={false} classNames={{ modalContainer: "list-selector" }}>
                <IonRow>
                    <IonRadioGroup className='radio-group' value={listSelectedId !== undefined ? listSelectedId.toString() : ""} onIonChange={(e) => { changeList(e); props.change?.(e) }}>
                        {props.children}
                    </IonRadioGroup>
                </IonRow>
            </Modal> : null}

        {props.type == 'select3' ?
            <Modal open={showList} onClose={() => setShowList(false)} blockScroll={false} center showCloseIcon={false} classNames={{ modalContainer: "list-selector" }}>
                <IonRow>
                    <IonRadioGroup className='radio-group' value={listSelectedId !== undefined ? listSelectedId.toString() : ""} onIonChange={(e) => { changeList(e); props.change?.(e.detail.value) }}>
                        {props.children}
                    </IonRadioGroup>
                </IonRow>
            </Modal> : null}
    </div>
}

export default InputItem